import Loading from "../../../components/Loading";
import { arrayMap, findItemByFiled } from "../../../utils/array.utils";
import { useGetGroupCarInfoQuery } from "../../../utils/carInfo.utils";
import { useGetAllCarInfoTypeQuery } from "../../../utils/carInfoType.utils";
import { RenderFields, optionGen } from "../../../utils/form.utils";
import { textCamelCase } from "../../../utils/string.utils";

export default function ForwardField({ watch, control, errors, setValue }) {
  const { loading: parentLoading, data: parentData } = useGetGroupCarInfoQuery({
    query: ``,
    key: `GetParentGroupCarInfoForStockListAdd`
  });

  const { loading: typeLoading, data: typeData } = useGetAllCarInfoTypeQuery({
    query: ``,
    key: `GetTypeDataForStockListAdd`
  });

  function handleTypeId(slug) {
    return typeData?.length ? findItemByFiled(typeData, "slug", slug)?.id : null;
  }

  let typeIds = {};

  const typeSlugs = arrayMap(typeData, (item) => item?.slug) || [];

  typeSlugs.forEach((element) => {
    typeIds[textCamelCase(element)] = handleTypeId(element);
  });

  function handleParentData(name) {
    return parentData[name] ? optionGen(parentData[name]) : [];
  }

  const forwardOptions = handleParentData("company");

  let fields = [
    {
      label: "Forward",
      name: "forward",
      type: "select",
      placeholder: "Select a forwar company",
      col: { md: 12 },
      options: forwardOptions
    }
  ];

  const isLoading = typeLoading || parentLoading;

  return (
    <>
      <Loading loading={isLoading} />
      {
        <RenderFields
          setValue={setValue}
          fields={fields}
          control={control}
          watch={watch}
          errors={errors}
        />
      }
    </>
  );
}
